<template>
  <div>
    <div class="save-btn">
      <Button v-if="editFlag == '1'" @click="$refs.change.open()">变更记录</Button>
      <Button @click="back('/offline/agreementManage/supplierAgreement')">返回</Button>
      <Button type="primary" @click="save">保存</Button>
    </div>

    <div class="form-wrap">
      <Form :model="detailList" ref="formRef" :label-width="110">
        <FormItem label="协议名称" prop="name" :rules="$units.formRule.required('请输入')">
          <Input v-model.trim="detailList.name" :maxlength="30" @on-blur="
            event => {
              detailList.name = event.target.value.trim();
            }
          " placeholder="协议名称" clearable />
        </FormItem>
        <FormItem label="协议编号" prop="covenantNo" :rules="$units.formRule.required('请输入')">
          <Input v-model="detailList.covenantNo" @on-blur="
            event => {
              detailList.covenantNo = event.target.value.trim();
            }
          " placeholder="协议编号" clearable />
        </FormItem>
        <FormItem label="协议类型" v-if="detailList.covenantLevel">
          <span class="label-text" v-if="detailList.covenantLevel == 1">主协议</span>
          <span class="label-text" v-else>补充协议</span>
        </FormItem>
        <FormItem label="主协议名称" v-if="detailList.covenantLevel != 1 && detailList.parentCovenantName">
          <span class="label-text">{{ detailList.parentCovenantName }}</span>
        </FormItem>
        <FormItem key="parentCovenantNo" label="主协议编号"
          v-if="detailList.covenantLevel != 1 && detailList.parentCovenantNo">
          <span class="label-text">{{ detailList.parentCovenantNo }}</span>
        </FormItem>
        <FormItem label="签约机构" key="signOrgId" prop="signOrgId" :rules="$units.formRule.required('请选择')">
          <Select v-model="detailList.signOrgId"
            :disabled="addParentFlag == '1' || levelCode != '10001'" clearable
            filterable @on-change="selectSignOrgChange">
            <Option :value="item.id" v-for="(item, index) in signOrgTreeList" :key="index">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="签约保司" prop="insuranceSupplierId" :rules="$units.formRule.required('请选择')">
          <Select v-model="detailList.insuranceSupplierId"
            :disabled="addParentFlag == '1'" clearable filterable
            @on-change="selectCompany">
            <Option :value="item.id" v-for="(item, index) in insuranceCompanyList" :key="index">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="保司性质" prop="insuranceSupplierType">
          <Select v-model="detailList.insuranceSupplierType" disabled placeholder="请选择签约保司">
            <Option value="1">总公司</Option>
            <Option value="2">分公司</Option>
          </Select>
        </FormItem>
        <FormItem label="出单机构" prop="issueOrgIds" :rules="$units.formRule.arrRequired('请选择')">
          <selectTree type="4" :selectAllChildren="true" :multiple="true" v-model="detailList.issueOrgIds"
            ref="selectTreeRef" :maxTagCount="1" :checkChild="true"></selectTree>
        </FormItem>
        <FormItem label="状态" prop="status" v-if="editFlag">
          <Select v-model="detailList.status" :disabled="editFlag == '1'">
            <Option value="0">待生效</Option>
            <Option value="1">生效中</Option>
            <Option value="2">已过期</Option>
            <Option value="3">已终止</Option>
          </Select>
        </FormItem>
        <FormItem label="生效日期" prop="startTime" key="startTime"
          :rules="$units.formRule.required('请选择生效日期', (trigger = 'change'), (type = 'date'))">
          <DatePicker confirm type="date" format="yyyy-MM-dd" @on-ok="changeDate('1')" split-panels
            v-model="detailList.startTime" placeholder="请选择"></DatePicker>
        </FormItem>
        <FormItem label="到期日期" prop="endTime" key="endTime"
          :rules="$units.formRule.required('请选择到期日期', (trigger = 'change'), (type = 'date'))">
          <DatePicker confirm @on-ok="changeDate('2')" type="date" format="yyyy-MM-dd" split-panels
            v-model="detailList.endTime" placeholder="请选择"></DatePicker>
        </FormItem>
        <FormItem label="签署日期" prop="registrationDate" key="registrationDate">
          <DatePicker type="date" format="yyyy-MM-dd" split-panels v-model="detailList.registrationDate"
            placeholder="请选择"></DatePicker>
        </FormItem>
        <FormItem label="附件" class="full" prop="fileJson">
          <div class="upload-box">
            <uploadNew v-model="detailList.fileJson" fileType="pdf" :muti="true" :showFileName="true"></uploadNew>
          </div>
        </FormItem>
        <FormItem label="备注" class="full" prop="remark">
          <Input type="textarea" :rows="3" :maxlength="200" :show-word-limit="true" v-model="detailList.remark"></Input>
        </FormItem>
        <FormItem v-if="detailList.status == 3" label="终止日期" prop="stopTime" key="stopTime"
          :rules="$units.formRule.required('请输入终止日期', 'change', 'date')">
          <DatePicker type="date" format="yyyy-MM-dd" split-panels v-model="detailList.stopTime" placeholder="请选择"
            @on-clear="detailList.stopMsg = ''"></DatePicker>
        </FormItem>
        <FormItem v-else label="终止日期" prop="stopTime" key="stopTime1">
          <DatePicker type="date" format="yyyy-MM-dd" split-panels v-model="detailList.stopTime" placeholder="请选择"
            @on-clear="detailList.stopMsg = ''"></DatePicker>
        </FormItem>
        <FormItem label="终止原因" key="stopMsg1" prop="stopMsg" :rules="$units.formRule.required('请输入')"
          v-if="detailList.stopTime" class="full">
          <Input type="textarea" :rows="3" :maxlength="100" :show-word-limit="true" v-model="detailList.stopMsg"></Input>
        </FormItem>
        <FormItem label="终止原因" key="stopMsg2" class="full" v-if="!detailList.stopTime && detailList.status == 3">
          <Input type="textarea" :rows="3" :maxlength="100" :show-word-limit="true" v-model="detailList.stopMsg"></Input>
        </FormItem>
      </Form>
    </div>

    <!-- 变更记录 -->
    <change-record ref="change" :id="detailList.id" :name="detailList.name"></change-record>
    <template v-if="detailList.covenantLevel == 1 && detailList.id">
      <p class="title">补充协议列表</p>
      <div class="tools-box">
        <Button type="warning" class="add-btn" @click="addSupplementAgreement">新增</Button>
      </div>
      <loading :isShow="$root.$children[0].isShowLoading" />
      <div class="table-box setTable">
        <Table :columns="columns" :data="detailList.sonCovenants" row-key="id">
          <template slot-scope="{ row }" slot="name">
            <span v-if='row.fileJson && row.fileJson != "\"\"" && row.fileJson != "[]"' class="fileName" @click="$refs.previewModal.open(JSON.parse(row.fileJson))">{{ row.name }}</span>
            <span v-else-if='!row.name'>-</span>
            <span v-else>{{ row.name }}</span>
          </template>
          <template slot-scope="{ row }" slot="status">
            <span v-show="row.status == '0'">待生效</span>
            <span v-show="row.status == '1'">生效中</span>
            <span v-show="row.status == '2'">已过期</span>
            <span v-show="row.status == '3'">已终止</span>
          </template>

          <template slot-scope="{ row }" slot="action">
            <a class="table-btn" @click="edit(row)">编辑</a>
            <a class="table-btn" @click="signProduct(row)">签约产品</a>
            <Dropdown :transfer="true" trigger="hover" transfer-class-name="salesman-manage-dropdown-menu table-btn"
              @on-click="dropdownClick($event, row)">
              <div class="more-btn">
                更多
                <Icon type="ios-arrow-down"></Icon>
              </div>
              <DropdownMenu slot="list">
                <DropdownItem name="copy">复制协议</DropdownItem>
                <DropdownItem name="stop" v-if="row.status != '2' && row.status != '3'">终止</DropdownItem>
                <DropdownItem name="del">删除</DropdownItem>
                <DropdownItem name="preview" v-if='row.fileJson && row.fileJson != "\"\"" && row.fileJson != "[]"'>协议文档预览
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </template>
        </Table>
      </div>
    </template>

    <stopAgreement ref="stop" :initList="refresh"></stopAgreement>
    <previewModal ref="previewModal"></previewModal>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import filters from '@/api/filter';
import { uploadFile } from '@/api/httpList';
import { common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
import uploadNew from '@/components/commons/uploadNew';
import changeRecord from './changeRecord';
import stopAgreement from '../stopAgreement';
import filter from '@/api/filter';
import previewModal from './../previewModal'
export default {
  mixins: [common],
  name: 'baseInfo',
  components: { selectTree, changeRecord, uploadNew, stopAgreement,previewModal },
  props: ['covenantId'],
  filters,
  data() {
    const _this = this;
    return {
      filter,
      levelCode: JSON.parse(localStorage.userInfo).levelCode,
      detailList: {
        id: '',
        covenantLevel: _this.$route.query.covenantLevel,
        covenantSource: 1, //协议种类（1、供应商代理协议2、渠道分销协议）
        covenantType: 1, //协议类型（1、保司协议2、通道协议）
        covenantNo: '', // 协议编号
        name: '', // 协议名称
        insuranceSupplierId: '', // 签约保司
        insuranceSupplierType: '', //保司性质
        signOrgId: '', // 签约机构
        issueOrgIds: [], //出单机构
        registrationDate: '', // 签署时间
        startTime: '', // 生效日期
        endTime: '', // 到期日期
        stopTime: '', //终止日期
        stopMsg: '', //终止原因
        fileUrl: '', //附件URL
        fileName: '', //附件名称
        remark: '' // 备注
      },
      stopTime: '',
      startTime: '', //父级生效日期
      endTime: '', //父级到期日期
      addParentFlag: null, //是否为新增补充协议(1:是、0：否)
      copyFlag: null, //复制协议(1:是、0：否)
      editFlag: 0, //编辑(1:是、0：否)
      backFlag: 0, //(1:是、0：否)
      signOrgTreeList: [], //签约机构
      issueOrgTreeList: [], //出单机构
      insuranceCompanyList: [], //签约保司
      copyId: null, //复制id
      columns: [
        {
          title: '协议名称',
          align: 'left',
          minWidth: 200,
          tree: true,
          slot: 'name',
          tooltip: true,
          className: 'name'
        },
        {
          title: '协议编号',
          minWidth: 120,
          align: 'center',
          key: 'covenantNo'
        },
        {
          title: '协议类型',
          minWidth: 80,
          align: 'center',
          render(h, params) {
            const covenantLevel = params.row.covenantLevel;
            return <span>{covenantLevel == '1' ? '主协议' : '补充协议'}</span>;
          }
        },
        {
          title: '状态',
          minWidth: 100,
          align: 'center',
          slot: 'status'
        },
        {
          title: '有效期',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            const endTime = params.row.endTime;
            const result = params.row.startTime;
            return (
              <span>
                {filters.filterTime(result, 'YYYY-MM-DD') || '-'} 至 {filters.filterTime(endTime, 'YYYY-MM-DD') || '-'}
              </span>
            );
          }
        },
        {
          title: '签约产品数量',
          minWidth: 120,
          align: 'center',
          key: 'productNum'
        },
        {
          title: '终止日期',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            const result = params.row.stopTime;
            const status = params.row.status;
            if (status === '3') {
              return <span>{filters.filterTime(result, 'YYYY-MM-DD') || '-'}</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '操作',
          width: 200,
          align: 'center',
          slot: 'action',
          fixed: 'right'
        }
      ]
    };
  },
  activated() {
    if (this.$route.query.backFlag != 1 && (this.$route.query.rowId || this.covenantId)) {
      this.$http({
        url: `/buz/covenant/read/detail?id=${this.covenantId || this.$route.query.rowId}`,
        type: 'GET'
      }).then(res => {
        this.detailList.sonCovenants = res.data.sonCovenants;
      });
    }
  },
  created() {
    if (this.levelCode != '10001') {
      this.detailList.signOrgId = JSON.parse(localStorage.userInfo).organId;
      this.selectSignOrgChange(JSON.parse(localStorage.userInfo).organId);
    }

    this.queryInsuranceCompanyList();
    this.querySignOrgTree();
    this.editFlag = this.$route.query.editFlag;
    this.backFlag = this.$route.query.backFlag;

    if (this.covenantId && this.editFlag == '1') {
      this.editFlag = this.$route.query.editFlag;
      this.queryDetail(this.$route.query.rowId);
    }

    // 新增补充协议获取详情
    if (this.$route.query.addParentFlag == '1') {
      this.addParentFlag = this.$route.query.addParentFlag;
      this.querySupplementDetail(this.$route.query.rowId);
    } else if (this.$route.query.addParentFlag == '0') {
      this.$nextTick(() => {
        this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange();
      });
    }

    // 复制协议获取详情
    if (this.$route.query.copyFlag == '1') {
      this.copyFlag = this.$route.query.copyFlag;
      this.copyAgreementDetail(this.$route.query.rowId);
    }
  },

  methods: {
    refresh() {
      if (this.$route.query.rowId) {
        this.queryDetail(this.$route.query.rowId);
      }
    },
    // 签约产品
    signProduct(row) {
      this.$router.push({
        path: '/offline/agreementManage/supplierAgreement/formEdit',
        query: {
          rowId: row.id,
          editFlag: 1,
          is_signProduct: 1,
          disabled: row.status == '2' || row.status == '3' ? 1 : 0,
          backFlag: 1
        }
      });
    },

    // 更多操作
    dropdownClick(name, row) {
      if (name == 'copy') {
        this.copyAgreement(row);
      } else if (name == 'stop') {
        this.$refs.stop.open(row);
      } else if (name == 'del') {
        this.submitDelete(row);
      } else if (name == 'preview') {
        this.$refs.previewModal.open(JSON.parse(row.fileJson))
      }
    },

    // 编辑
    edit(row) {
      this.openPageTabTags(
        '/offline/agreementManage/supplierAgreement/formEdit',
        {
          editFlag: 1,
          rowId: row.id,
          backFlag: 1
        }
      );
    },

    // 新增补充协议
    addSupplementAgreement() {
      this.openPageTabTags(
        '/offline/agreementManage/supplierAgreement/addSupplementform',
        {
          covenantLevel: 2,
          addParentFlag: 1,
          rowId: this.detailList.id,
          parentCovenantName: this.detailList.name,
          parentCovenantNo: this.detailList.covenantNo
        }
      );
    },
    // 删除
    async submitDelete(item) {
      let checkDel = await this.$http({
        url: `/buz/covenant/checkDel?id=${item.id}`,
        type: 'GET'
      });
      this.$notice.inquiry(checkDel.data ? '确认删除操作？' : '该协议的签约产品已产生关联保单，请确认是否删除？').then(async () => {
        this.$http({
          url: `/buz/covenant/del?id=${item.id}`,
          type: 'GET'
        }).then(res => {
          this.$Message.success('删除成功');
          this.refresh();
        });
      });
    },
    // 复制协议
    copyAgreement(row) {
      this.openPageTabTags(
        '/offline/agreementManage/supplierAgreement/formCopy',
        {
          copyFlag: 1,
          rowId: row.id,
          backFlag: 1
        }
      );
    },
    changeDate(type) {
      if (!this.detailList.id) return;
      let _this = this;
      let params = {
        id: this.detailList.id,
        type, //1、检测生效日 2、检测到期日",
        checkDate: type == 1 ? this.detailList.startTime : this.detailList.endTime
      };
      if (
        this.detailList.status == 1 ||
        this.detailList.status == 2 ||
        (this.detailList.status == 3 && dayjs(_this.detailList.stopTime).isAfter(dayjs(_this.detailList.startTime)))
      ) {
        //生效中/已过期的协议 终止日期在协议有效期之内的已终止协议
        //生效日期编辑：可以往前修改，如果往后修改那么选择某日期后判断该日期之前是否已有关联保单，如有则即时提示：该日期之前已有关联保单，请确认是否修改？
      }
      this.$http({
        url: '/buz/covenant/checkDate',
        type: 'POST',
        forced: true,
        data: params
      }).then(res => {
        if (!res.data) {
          this.$notice
            .inquiry(type == 1 ? '该日期之前已有关联保单，请确认是否修改？' : '该日期之后已有关联保单，请确认是否修改？')
            .then(() => { })
            .catch(() => {
              type == 1 ? this.detailList.startTime = this.startTime : this.detailList.endTime = this.endTime
            });
        }
      });
    },
    // 查询签约保司
    queryInsuranceCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        this.insuranceCompanyList = res.data;
      });
    },

    // 详情
    queryDetail(id) {
      this.$http({
        url: `/buz/covenant/read/detail?id=${this.covenantId || id}`,
        type: 'GET'
      }).then(res => {
        if (res.data.stopTime) {
          res.data.stopTime = new Date(res.data.stopTime);
        }
        this.startTime = res.data.covenantLevel == '2' ? res.data.parentStartTime : res.data.startTime; //主协议生效日期
        this.endTime = res.data.covenantLevel == '2' ? res.data.parentEndTime : res.data.endTime; //主协议到期日期
        this.stopTime = res.data.stopTime; //主协议到期日期
        this.detailList = res.data;
        this.detailList.signOrgId = res.data.signOrgId;
        // this.detailList.fileJson = res.data.fileJson ? JSON.parse(res.data.fileJson) : '';
        try {
          this.detailList.fileJson = res.data.fileJson ? JSON.parse(res.data.fileJson) : [];
        } catch {
          this.detailList.fileJson = [
            {
              path: res.data.fileJson
            }
          ];
        }
        this.$nextTick(() => {
          this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange();
        });
        if (this.editFlag == '1') {
          this.$emit('is-submit', true, res.data.id, res.data.status);
        }
      });
    },

    // 新增补充协议-详情
    querySupplementDetail(id) {
      this.$nextTick(() => {
        this.$refs.formRef.resetFields();
      });
      this.$http({
        url: `/buz/covenant/read/detail?id=${id}`,
        type: 'GET'
      }).then(res => {
        this.startTime = res.data.covenantLevel == '2' ? res.data.parentStartTime : res.data.startTime; //主协议生效日期
        this.endTime = res.data.covenantLevel == '2' ? res.data.parentEndTime : res.data.endTime; //主协议到期日期
        this.detailList = {
          ...res.data,
          parentId: res.data.id,
          covenantLevel: '2',
          name: '',
          covenantNo: '',
          startTime: '',
          endTime: '',
          registrationDate: '',
          fileJson: [],
          remark: '',
          stopTime: '',
          stopMsg: '',
          status: '',
          productNum: '',
          parentCovenantName: res.data.parentCovenantName || this.$route.query.parentCovenantName,
          parentCovenantNo: res.data.parentCovenantNo || this.$route.query.parentCovenantNo
        };
        this.selectSignOrgChange(res.data.signOrgId);
        this.$nextTick(() => {
          this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange();
        });
        delete this.detailList.id;
      });
    },

    // 复制协议-详情
    copyAgreementDetail(id) {
      this.$http({
        url: `/buz/covenant/read/detail?id=${id}`,
        type: 'GET'
      }).then(res => {
        this.copyId = res.data.id;
        this.startTime = res.data.covenantLevel == '2' ? res.data.parentStartTime : res.data.startTime; //主协议生效日期
        this.endTime = res.data.covenantLevel == '2' ? res.data.parentEndTime : res.data.endTime; //主协议到期日期
        delete res.data.id;
        this.detailList = {
          ...res.data,
          covenantNo: '', //编号
          status: '', //状态
          startTime: '', //生效时间
          endTime: '', //到期日期
          registrationDate: '', //签署日期
          fileUrl: '', //附件url
          fileName: '', //附件名称
          fileJson: [],
          stopTime: '', //终止日期
          stopMsg: '' //终止原因
        };
        this.$nextTick(() => {
          this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange();
        });
      });
    },

    // 查询签约机构
    querySignOrgTree() {
      this.$http({
        url: `/buz/organizationBase/read/list`,
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 9999,
          orgTypes: ['1', '2', '3', '4'],
          status: 1
        }
      }).then(res => {
        this.signOrgTreeList = res.data;
      });
    },

    dealTree(arr) {
      return arr.map(item => ({
        ...item,
        value: item.id,
        label: item.name,
        title: item.name,
        expand: true,
        children: item.children && item.children.length > 0 ? this.dealTree(item.children, item.name) : null
      }));
    },

    // 选中签约机构
    selectSignOrgChange(data) {
      if (!this.covenantId && this.addParentFlag != '1' && this.copyFlag != '1' && this.editFlag != '1') {
        this.detailList.issueOrgIds = [];
      }
      setTimeout(() => {
        this.$refs.selectTreeRef && this.$refs.selectTreeRef.selectChild(data);
      }, 100);

      this.$http({
        url: `/buz/organizationBase/read/orgTree`,
        type: 'POST',
        data: {
          source: '2',
          orgId: data,
          isSelectTop: '1'
        }
      }).then(res => {
        this.issueOrgTreeList = this.dealTree([res.data]);
      });
    },

    // 选中签约保司
    selectCompany(value) {
      if (value) {
        this.detailList.insuranceSupplierType = this.insuranceCompanyList.filter(item => item.id === value)[0].companyType;
      }
    },

    // 附件上传
    handleUpload(file) {
      const reg = /\.(pdf)$/;
      const txt = 'PDF';
      if (!reg.test(file.name.toLowerCase())) {
        this.$Message.error(`上传格式不正确，请上传${txt}格式文件`);
        return;
      }
      let formData = new FormData();
      formData.append('file', file);
      uploadFile(formData).then(res => {
        this.$set(this.detailList, 'fileUrl', res.data[0].path);
        this.$set(this.detailList, 'fileName', res.data[0].fileName);
      });
    },

    // 关闭当前页面
    close() {
      window.parent.postMessage(
        {
          removePageTag: '/offline/agreementManage/supplierAgreement/form',
          appMessage: true
        },
        '*'
      );
    },

    // 保存
    save() {
      this.$refs.formRef.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.detailList));
        const registrationDate = formData.registrationDate ? this.filter.filterTime(formData.registrationDate, 'YYYY-MM-DD') : ''; //签署日期
        const startTime = this.filter.filterTime(formData.startTime, 'YYYY-MM-DD 00:00:00'); //生效日期
        const endTime = this.filter.filterTime(formData.endTime, 'YYYY-MM-DD 23:59:59'); //到期日期
        const stopTime = this.filter.filterTime(formData.stopTime, 'YYYY-MM-DD 23:59:59'); //终止日期
        let _this = this;
        if (formData.id) {
          //编辑时校验
          let msg = '';
          if (formData.status == 0) {
            //编辑页、协议状态为待生效
            //终止日期编辑：不晚于到期日期即可
            dayjs(stopTime).isAfter(dayjs(endTime)) ? (msg = '终止日期不晚于到期日期') : '';
          } else if (
            formData.status == 1 ||
            formData.status == 2 ||
            (formData.status == 3 && dayjs(_this.stopTime).isAfter(dayjs(startTime)))
          ) {
            //编辑页、协议状态为生效中/已过期
            //终止日期编辑：需在协议有效期区间内
            dayjs(stopTime).isBefore(dayjs(startTime)) || dayjs(stopTime).isAfter(dayjs(endTime))
              ? (msg = '终止日期需在协议有效期区间内')
              : ''; //到期日期
          } else if (formData.status == 3) {
            //终止日期在协议有效期之前的已终止协议：
            //如果有效期改为未来了，终止日期不晚于到期日期即可，如果不是未来，则需在有效期间
            if (dayjs(stopTime).isAfter(dayjs(endTime)) && dayjs().isAfter(dayjs(startTime))) {
              msg = '终止日期需在协议有效期区间内';
            } else if (dayjs(stopTime).isAfter(dayjs(endTime)) && dayjs().isBefore(dayjs(startTime))) {
              msg = '终止日期不晚于到期日期';
            }
          }
          if (msg) {
            return this.$Message.error(msg);
          }
        }
        if (startTime > endTime) {
          return this.$Message.error('生效日期不能大于到期日期');
        }
        // if (this.addParentFlag == '1' || (this.copyFlag == '1' && formData.covenantLevel == '2')) {
        //     if (this.filter.filterTime(startTime, 'YYYY-MM-DD') < this.filter.filterTime(this.startTime, 'YYYY-MM-DD')) {
        //         return this.$Message.error('生效日期不能小于主协议生效日期');
        //     }

        //     if (this.filter.filterTime(endTime, 'YYYY-MM-DD') > this.filter.filterTime(this.endTime, 'YYYY-MM-DD')) {
        //         return this.$Message.error('到期日期不能大于主协议的到期日期');
        //     }
        // }
        let addData = {
          ...formData,
          fileJson: JSON.stringify(formData.fileJson),
          startTime,
          endTime,
          registrationDate,
          stopTime: formData.stopTime && formData.stopTime != '-' ? stopTime : ''
        };
        // 复制
        if (this.copyFlag == '1') {
          addData.isCopy = '1';
          addData.copyId = this.copyId;
        }

        let is_signProduct = this.$route.query.is_signProduct; //首页列表进入签约产品
        this.$http({
          url: !this.editFlag && is_signProduct != '1' ? '/buz/covenant/add' : '/buz/covenant/edit',
          type: 'POST',
          data: addData,
          apiPermissionCode:'pro_6_1'
        }).then(res => {
          this.$notice.success('保存成功');
          if (!this.editFlag || this.backFlag) {
            setTimeout(() => {
              this.back();
            }, 1000);
          } else {
            this.detailList.status = res.data.status;
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import './baseInfo.scss';
.fileName{
  cursor: pointer;
  color: #236DFF;
}
.table-box {
  padding-bottom: 20px;
}

.title {
  font-weight: 600;
  margin: 8px 0;
}

.more-btn {
  width: 60px;
  height: 24px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 10px;
  background: #f4f7ff;
  border: 2px;
  color: #236dff;
  font-size: 13px;
}
</style>
